module.exports = __webpack_public_path__ + "img/delete.7bcd35e1.svg";